define([
    'react',
    'lodash',
    'icons/icon'
], function (React, _, Icon) {
    'use strict';
    function onClick1(e) {
        {
            this.onClick(e);
        }
    }
    return function () {
        return React.createElement('div', {
            'className': this.getClass(),
            'onClick': onClick1.bind(this)
        }, '\r\n  ', this.getChildren(), '\r\n');
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-column/table-column.rt
 ** module id = 207
 ** module chunks = 0
 **/